import Subject from "../cse4sub/Subject";
import React from 'react'
import CSE301mid from '../assets/CSE301mid21.pdf'
import CSE301 from '../assets/CSE301end21.pdf'

export default function Aec() {
  return (
    <div>
       <Subject title="Analog Electronic Circuit(CSE301)"
    book1="S. Sedra and K. C. Smith, “Microelectronic Circuits”, New York, Oxford University Press, 1998."
     book2="J. V. Wait, L. P. Huelsman and G. A. Korn, “Introduction to Operational Amplifier theory and 
     applications”, McGraw Hill U. S., 1992"
    book1Link="https://www.pdfdrive.com/download.pdf?id=166968600&h=c1d3360448853d7d0ff9ca2532c41e3e&u=cache&ext=pdf
    " book2Link="https://xdevs.com/doc/_Books/OpAmp/analysis%20and%20design%20of%20analog%20integrated%20circuits.pdf
    " int21="#" mid21={CSE301mid} end21={CSE301}
     int20="#" mid20="#" end20="#" mid="Q. Paper"
    />
    </div>
  )
}